import { render } from "./ProfessionsView.vue?vue&type=template&id=4e3a18fc&scoped=true"
import script from "./ProfessionsView.vue?vue&type=script&lang=js"
export * from "./ProfessionsView.vue?vue&type=script&lang=js"

import "./ProfessionsView.vue?vue&type=style&index=0&id=4e3a18fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3a18fc"]])

export default __exports__